<div class="charts-container">
    <galaxy-chart *ngFor="let chartData of chartsArray" [data]="chartData"></galaxy-chart>
</div>